import * as React from 'react';

export type SocialButtonIcons =
  | 'facebook'
  | 'instagram'
  | 'twitter'
  | 'pinterest'
  | 'youtube'
  | 'linkedin'
  | 'xcorp'
  | 'tiktok';

export interface SocialButtonProps {
  /** Text for the button */
  text?: React.ReactNode;
  /** Share button social network type */
  icon?: SocialButtonIcons;
  /** hook for testing purposes */
  dataHook?: string;
  /** Disable button */
  disabled?: boolean;
  /** Click handler */
  onClick?: React.EventHandler<React.MouseEvent<HTMLElement>>;
}

declare const SocialButton: React.FC<SocialButtonProps>;

export { SocialButton };
